import { SET_USER, CLEAR } from "./actionTypes";
import { api } from "../../common/api";

export const setUser = (userData: any) => {
  return {
    type: SET_USER,
    payload: userData,
  };
};

// Helper function to fetch STAFF permissions
const fetchStaffPermissions = async () => {
  const { data } = await api({
    url: `/role-permission/STAFF`,
    method: "get",
  });
  return data;
};

// New action to refresh permissions for logged-in STAFF and MO users
export const refreshPermissions = () => {
  return async (dispatch: any, getState: any) => {
    const user = getState().user;

    // Only refresh for STAFF and MO users
    if (!user || (user.role !== "STAFF" && user.role !== "MO")) {
      return Promise.resolve();
    }

    // For MO users, just hardcode the pushNotification permission
    if (user.role === "MO") {
      console.log("Setting hardcoded permissions for MO user...");
      dispatch({
        type: SET_USER,
        payload: {
          ...user,
          permissions: {
            pushNotification: "EDITABLE",
          },
        },
      });
      return Promise.resolve();
    }

    // For STAFF users, fetch from server
    try {
      const response = await fetchStaffPermissions();
      console.log("Permissions API response:", response);

      if (
        !response.serverResponse.isError &&
        response.result.data?.permissions
      ) {
        console.log(
          "Updating STAFF user with permissions:",
          response.result.data.permissions
        );
        dispatch({
          type: SET_USER,
          payload: {
            ...user,
            permissions: response.result.data.permissions,
          },
        });
      } else {
        console.log("No permissions found or error in response");
      }
    } catch (err) {
      console.error(`Failed to refresh permissions:`, err);
    }

    return Promise.resolve();
  };
};

export const clearUser = () => {
  return {
    type: CLEAR,
  };
};
